const state = {
  chartsConfig: localStorage.getItem('chartsConfig')
    ? JSON.parse(localStorage.getItem('chartsConfig'))
    : null,
  filtersConfig: localStorage.getItem('filtersConfig')
    ? JSON.parse(localStorage.getItem('filtersConfig'))
    : null,
  sites: localStorage.getItem('sites') ? JSON.parse(localStorage.getItem('sites')) : null,
  sitesWithMaps: localStorage.getItem('sitesWithMaps')
    ? JSON.parse(localStorage.getItem('sitesWithMaps'))
    : null,
  sitesWithSurvey: localStorage.getItem('sitesWithSurvey')
    ? JSON.parse(localStorage.getItem('sitesWithSurvey'))
    : null,
}

const getters = {
  chartsConfig: state => state.chartsConfig,
  filtersConfig: state => state.filtersConfig,
  sitesWithMaps: state => state.sitesWithMaps,
  sitesWithSurvey: state => state.sitesWithSurvey,
}

const mutations = {
  setChartsConfig: (state, config) => {
    state.chartsConfig = config
    localStorage.setItem('chartsConfig', JSON.stringify(state.chartsConfig))
  },
  setFiltersConfig: (state, config) => {
    state.filtersConfig = config
    localStorage.setItem('filtersConfig', JSON.stringify(state.filtersConfig))
  },
  setSites: (state, sites) => {
    state.sites = sites
    localStorage.setItem('sites', JSON.stringify(state.sites))
  },
  setSitesWithMaps: (state, sites) => {
    state.sitesWithMaps = sites
    localStorage.setItem('sitesWithMaps', JSON.stringify(state.sitesWithMaps))
  },
  setSitesWithSurvey: (state, sites) => {
    state.sitesWithSurvey = sites
    localStorage.setItem('sitesWithSurvey', JSON.stringify(state.sitesWithSurvey))
  },
  removeConfig: state => {
    state.chartsConfig = null
    state.filtersConfig = null
    state.sites = null
    localStorage.removeItem('chartsConfig')
    localStorage.removeItem('filtersConfig')
    localStorage.removeItem('sites')
    localStorage.removeItem('sitesWithMaps')
    localStorage.removeItem('sitesWithSurvey')
  },
}

const actions = {
  setCurrentChartsConfig: ({ commit }, config) => {
    commit('setChartsConfig', config)
  },
  setCurrentFiltersConfig: ({ commit }, config) => {
    commit('setFiltersConfig', config)
  },
  setCurrentSites: ({ commit }, sites) => {
    commit('setSites', sites)
  },
  setCurrentSitesWithMaps: ({ commit }, sites) => {
    commit('setSitesWithMaps', sites)
  },
  setCurrentSitesWithSurvey: ({ commit }, sites) => {
    commit('setSitesWithSurvey', sites)
  },
  removeCurrentConfig: ({ commit }) => {
    commit('removeConfig')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
